import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "columns small-12 medium-12 large-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", null, "Allowed Values", -1 /* HOISTED */);
const _hoisted_3 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_4 = { class: "button-wrapper text-left" };
import { ref, watch } from "vue";
import Button from "src/shared/v-components/ui/Button.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AllowedValuesEditor',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const localValues = ref([...props.modelValue]);
        watch(() => props.modelValue, (newValues) => {
            localValues.value = [...newValues];
        }, { deep: true });
        const addValue = () => {
            localValues.value.push("");
            emitUpdate();
        };
        const removeValue = (index) => {
            localValues.value.splice(index, 1);
            if (localValues.value.length === 0) {
                localValues.value.push("");
            }
            emitUpdate();
        };
        const emitUpdate = () => {
            emit("update:modelValue", localValues.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (value, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "input-wrapper"
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event) => ((localValues.value[index]) = $event),
                            type: "text",
                            placeholder: 'Enter allowed value ' + (index + 1),
                            onInput: emitUpdate
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
                            [_vModelText, localValues.value[index]]
                        ]),
                        (_ctx.modelValue.length > 1)
                            ? (_openBlock(), _createBlock(Button, {
                                key: 0,
                                level: 'secondary',
                                onClick: ($event) => (removeValue(index))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Remove ")
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                            : _createCommentVNode("v-if", true)
                    ]));
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(Button, {
                        level: 'secondary',
                        onClick: addValue
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" + Add Value ")
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
